module.exports = __webpack_public_path__ + "img/character02_static.d3ea2792.png";